import axios from 'axios';
import authHeader from './../auth-header';
const API_URL = process.env.VUE_APP_API_URL;

class PaymentsService {
   fetchDoctorPayments(doctor_id, page_no){
       return axios.get(`${API_URL}/doctors/${doctor_id}/doctorpayments?page=${page_no}`, {headers: authHeader()});
   }
}

export default new PaymentsService();
